// AUTO-GENERATED by packages/emerald-converter/src/extract-sprites-cli.ts.
// Do not edit by hand. Run `pnpm --filter @poke/emerald-converter extract-sprites` to regenerate.

export type SpriteLayout = 'directional-9' | 'directional-3' | 'static';

export interface SpriteManifestEntry {
  gfxSymbol: string;
  width: number;
  height: number;
  frameWidth: number;
  frameHeight: number;
  frameCount: number;
  layout: SpriteLayout;
}

export const SPRITE_MANIFEST = {
  "red_normal": {
    "gfxSymbol": "OBJ_EVENT_GFX_RED_NORMAL",
    "width": 144,
    "height": 32,
    "frameWidth": 16,
    "frameHeight": 32,
    "frameCount": 9,
    "layout": "directional-9"
  },
  "woman_1": {
    "gfxSymbol": "OBJ_EVENT_GFX_WOMAN_1",
    "width": 160,
    "height": 32,
    "frameWidth": 16,
    "frameHeight": 32,
    "frameCount": 10,
    "layout": "directional-9"
  },
  "fat_man": {
    "gfxSymbol": "OBJ_EVENT_GFX_FAT_MAN",
    "width": 144,
    "height": 32,
    "frameWidth": 16,
    "frameHeight": 32,
    "frameCount": 9,
    "layout": "directional-9"
  },
  "prof_oak": {
    "gfxSymbol": "OBJ_EVENT_GFX_PROF_OAK",
    "width": 144,
    "height": 32,
    "frameWidth": 16,
    "frameHeight": 32,
    "frameCount": 9,
    "layout": "directional-9"
  },
  "clerk": {
    "gfxSymbol": "OBJ_EVENT_GFX_CLERK",
    "width": 144,
    "height": 32,
    "frameWidth": 16,
    "frameHeight": 32,
    "frameCount": 9,
    "layout": "directional-9"
  },
  "boy": {
    "gfxSymbol": "OBJ_EVENT_GFX_BOY",
    "width": 160,
    "height": 32,
    "frameWidth": 16,
    "frameHeight": 32,
    "frameCount": 10,
    "layout": "directional-9"
  },
  "old_man_1": {
    "gfxSymbol": "OBJ_EVENT_GFX_OLD_MAN_1",
    "width": 160,
    "height": 32,
    "frameWidth": 16,
    "frameHeight": 32,
    "frameCount": 10,
    "layout": "directional-9"
  },
  "woman_3": {
    "gfxSymbol": "OBJ_EVENT_GFX_WOMAN_3",
    "width": 144,
    "height": 32,
    "frameWidth": 16,
    "frameHeight": 32,
    "frameCount": 9,
    "layout": "directional-9"
  },
  "youngster": {
    "gfxSymbol": "OBJ_EVENT_GFX_YOUNGSTER",
    "width": 160,
    "height": 32,
    "frameWidth": 16,
    "frameHeight": 32,
    "frameCount": 10,
    "layout": "directional-9"
  },
  "blue": {
    "gfxSymbol": "OBJ_EVENT_GFX_BLUE",
    "width": 144,
    "height": 32,
    "frameWidth": 16,
    "frameHeight": 32,
    "frameCount": 9,
    "layout": "directional-9"
  },
  "mom": {
    "gfxSymbol": "OBJ_EVENT_GFX_MOM",
    "width": 48,
    "height": 32,
    "frameWidth": 16,
    "frameHeight": 32,
    "frameCount": 3,
    "layout": "directional-3"
  },
  "item_ball": {
    "gfxSymbol": "OBJ_EVENT_GFX_ITEM_BALL",
    "width": 16,
    "height": 16,
    "frameWidth": 16,
    "frameHeight": 16,
    "frameCount": 1,
    "layout": "static"
  },
  "cut_tree": {
    "gfxSymbol": "OBJ_EVENT_GFX_CUT_TREE",
    "width": 64,
    "height": 16,
    "frameWidth": 16,
    "frameHeight": 16,
    "frameCount": 4,
    "layout": "static"
  },
  "brock": {
    "gfxSymbol": "OBJ_EVENT_GFX_BROCK",
    "width": 48,
    "height": 32,
    "frameWidth": 16,
    "frameHeight": 32,
    "frameCount": 3,
    "layout": "directional-3"
  },
  "bug_catcher": {
    "gfxSymbol": "OBJ_EVENT_GFX_BUG_CATCHER",
    "width": 160,
    "height": 32,
    "frameWidth": 16,
    "frameHeight": 32,
    "frameCount": 10,
    "layout": "directional-9"
  },
  "daisy": {
    "gfxSymbol": "OBJ_EVENT_GFX_DAISY",
    "width": 144,
    "height": 32,
    "frameWidth": 16,
    "frameHeight": 32,
    "frameCount": 9,
    "layout": "directional-9"
  },
  "camper": {
    "gfxSymbol": "OBJ_EVENT_GFX_CAMPER",
    "width": 160,
    "height": 32,
    "frameWidth": 16,
    "frameHeight": 32,
    "frameCount": 10,
    "layout": "directional-9"
  },
  "cooltrainer_f": {
    "gfxSymbol": "OBJ_EVENT_GFX_COOLTRAINER_F",
    "width": 160,
    "height": 32,
    "frameWidth": 16,
    "frameHeight": 32,
    "frameCount": 10,
    "layout": "directional-9"
  },
  "gba_kid": {
    "gfxSymbol": "OBJ_EVENT_GFX_GBA_KID",
    "width": 48,
    "height": 32,
    "frameWidth": 16,
    "frameHeight": 32,
    "frameCount": 3,
    "layout": "directional-3"
  },
  "gentleman": {
    "gfxSymbol": "OBJ_EVENT_GFX_GENTLEMAN",
    "width": 160,
    "height": 32,
    "frameWidth": 16,
    "frameHeight": 32,
    "frameCount": 10,
    "layout": "directional-9"
  },
  "gym_guy": {
    "gfxSymbol": "OBJ_EVENT_GFX_GYM_GUY",
    "width": 144,
    "height": 32,
    "frameWidth": 16,
    "frameHeight": 32,
    "frameCount": 9,
    "layout": "directional-9"
  },
  "lass": {
    "gfxSymbol": "OBJ_EVENT_GFX_LASS",
    "width": 160,
    "height": 32,
    "frameWidth": 16,
    "frameHeight": 32,
    "frameCount": 10,
    "layout": "directional-9"
  },
  "man": {
    "gfxSymbol": "OBJ_EVENT_GFX_MAN",
    "width": 160,
    "height": 32,
    "frameWidth": 16,
    "frameHeight": 32,
    "frameCount": 10,
    "layout": "directional-9"
  },
  "nurse": {
    "gfxSymbol": "OBJ_EVENT_GFX_NURSE",
    "width": 64,
    "height": 32,
    "frameWidth": 16,
    "frameHeight": 32,
    "frameCount": 4,
    "layout": "static"
  },
  "pokedex": {
    "gfxSymbol": "OBJ_EVENT_GFX_POKEDEX",
    "width": 16,
    "height": 16,
    "frameWidth": 16,
    "frameHeight": 16,
    "frameCount": 1,
    "layout": "static"
  },
  "rocker": {
    "gfxSymbol": "OBJ_EVENT_GFX_ROCKER",
    "width": 160,
    "height": 32,
    "frameWidth": 16,
    "frameHeight": 32,
    "frameCount": 10,
    "layout": "directional-9"
  },
  "scientist": {
    "gfxSymbol": "OBJ_EVENT_GFX_SCIENTIST",
    "width": 160,
    "height": 32,
    "frameWidth": 16,
    "frameHeight": 32,
    "frameCount": 10,
    "layout": "directional-9"
  },
  "woman_2": {
    "gfxSymbol": "OBJ_EVENT_GFX_WOMAN_2",
    "width": 160,
    "height": 32,
    "frameWidth": 16,
    "frameHeight": 32,
    "frameCount": 10,
    "layout": "directional-9"
  },
  "worker_f": {
    "gfxSymbol": "OBJ_EVENT_GFX_WORKER_F",
    "width": 160,
    "height": 32,
    "frameWidth": 16,
    "frameHeight": 32,
    "frameCount": 10,
    "layout": "directional-9"
  },
  "jigglypuff": {
    "gfxSymbol": "OBJ_EVENT_GFX_JIGGLYPUFF",
    "width": 48,
    "height": 16,
    "frameWidth": 16,
    "frameHeight": 16,
    "frameCount": 3,
    "layout": "static"
  }
} as const satisfies Record<string, SpriteManifestEntry>;

export type SpriteKey = keyof typeof SPRITE_MANIFEST;
